import { ENTRIES_ROUTES } from '../../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import entriesTypes from '../../constants/entriesTypes'
import { axios } from '../../services'

const feed_entries_set_filters = (filters) => {
  return {
    type: entriesTypes.set_filters,
    payload: filters
  }
}

const feed_entries_um_set_icon = () => {
  return {
    type: entriesTypes.um.set_icon
  }
}

const batch_update_request = () =>{
  return {
    type: entriesTypes.batch_update.request
  }
}

const batch_update_success = (response) => {
  return {
    type: entriesTypes.index.success,
    payload: response.data
  }
}

const batch_update_failure = (messages) => {
  return {
    type: entriesTypes.batch_update.failure,
    payload: messages
  }
}

const dry_batch_update_request = () => {
  return {
    type: entriesTypes.dry_batch_update.request
  }
}

const dry_batch_update_failure = (messages) => {
  return {
    type: entriesTypes.dry_batch_update.failure,
    payload: messages
  }
}

const dry_batch_update_success = (response) => {
  return {
    type: entriesTypes.dry_batch_update.success,
    payload: response.data
  }
}

const batch_update_entries = (feed_id, filters, operations, dry=false) => {
  return function (dispatch) {
    // REQUEST
    if (dry === true) {
      dispatch(dry_batch_update_request())
    } else {
      dispatch(batch_update_request())
    }

    axios.patch(
      formatRoute(ENTRIES_ROUTES.batch_update, {feed_id: feed_id}),
      {
        filters: filters,
        operations: operations,
        dry: (dry === true),
        page: 1,
        per_page: 50
      }

    ).then( response => {
      // success
      if (dry === true) {
        dispatch( dry_batch_update_success(response) )
      } else {
        dispatch( batch_update_success(response) )
        dispatch( feed_entries_set_filters(filters) )
        // dispatch( feed_entries_um_set_icon() )
      }

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Operation failed"]
      }
      if (dry === true) {
        dispatch( dry_batch_update_failure(errors) )
      } else {
        dispatch( batch_update_failure(errors) )
      }
    })
  }
}

const reset_dry_text = () => {
  return {
    type: entriesTypes.dry_batch_update.reset
  }
}

// bulk rows operations common dispatchers
const bulk_rows_request = () => {
  return {
    type: entriesTypes.bulk_rows.request
  }
}

const bulk_rows_failure = (messages) => {
  return {
    type: entriesTypes.bulk_rows.failure,
    payload: messages
  }
}

// mark multiple items as read (remove newentry flag)
const multiple_mark_read_success = (response) => {
  return {
    type: entriesTypes.multiple_mark_read.success,
    payload: response.data
  }
}

const multiple_mark_read = ( feed_id, entry_ids ) => {
  return function (dispatch) {
    // REQUEST
    dispatch(bulk_rows_request())

    axios.post(
      formatRoute(ENTRIES_ROUTES.multiple_mark_read, {feed_id: feed_id}),
      {
        ids: entry_ids
      }

    ).then( response => {
      // success
      dispatch( multiple_mark_read_success(response) )
      if ( response.data && response.data.entries !== undefined && response.data.entries !== undefined && Object.keys(response.data.entries).length > 0) {
        dispatch( feed_entries_um_set_icon() )
      } else {
        window.M.toast({html: "All selected items were already marked viewed"})
      }

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Operation failed"]
      }
      dispatch( bulk_rows_failure(errors) )
    })
  }
}

// publish multiple items
const multiple_publish_success = (response) => {
  return {
    type: entriesTypes.multiple_publish.success,
    payload: response.data
  }
}

const multiple_publish = ( feed_id, entry_ids ) => {
  return function (dispatch) {
    // REQUEST
    dispatch(bulk_rows_request())

    axios.post(
      formatRoute(ENTRIES_ROUTES.multiple_publish, {feed_id: feed_id}),
      {
        ids: entry_ids
      }

    ).then( response => {
      // success
      dispatch( multiple_publish_success(response) )
      if ( response.data && response.data.entries !== undefined && response.data.entries !== undefined && Object.keys(response.data.entries).length > 0) {
        dispatch( feed_entries_um_set_icon() )
      } else {
        window.M.toast({html: "All selected items were already published"})
      }

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Operation failed"]
      }
      dispatch( bulk_rows_failure(errors) )
    })
  }
}

// unpublish multiple items
const multiple_unpublish_success = (response) => {
  return {
    type: entriesTypes.multiple_unpublish.success,
    payload: response.data
  }
}

const multiple_unpublish = ( feed_id, entry_ids ) => {
  return function (dispatch) {
    // REQUEST
    dispatch(bulk_rows_request())

    axios.post(
      formatRoute(ENTRIES_ROUTES.multiple_unpublish, {feed_id: feed_id}),
      {
        ids: entry_ids
      }

    ).then( response => {
      // success
      dispatch( multiple_unpublish_success(response) )
      console.log(response.data.entries)
      if ( response.data && response.data.entries !== undefined && response.data.entries !== undefined && Object.keys(response.data.entries).length > 0) {
        dispatch( feed_entries_um_set_icon() )
      } else {
        window.M.toast({html: "All selected items were already unpublished"})
      }

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Operation failed"]
      }
      dispatch( bulk_rows_failure(errors) )
    })
  }
}

// populate description with title if empty
const populate_description_request = () => {
  return {
    type: entriesTypes.index.request
  }
}

const populate_description_success = (response) => {
  return {
    type: entriesTypes.index.success,
    payload: response.data
  }
}

const populate_description_failure = (messages) => {
  return {
    type: entriesTypes.index.failure,
    payload: messages
  }
}

const populate_description = ( feed_id ) => {
  return function (dispatch) {
    // REQUEST
    dispatch(populate_description_request())

    axios.post(
      formatRoute(ENTRIES_ROUTES.populate_description, {id: feed_id})

    ).then( response => {
      // success
      dispatch( populate_description_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Operation failed"]
      }
      dispatch( populate_description_failure(errors) )
    })
  }
}


export {
  batch_update_entries,
  reset_dry_text,
  multiple_mark_read,
  multiple_publish,
  multiple_unpublish,
  populate_description
}



// WEBPACK FOOTER //
// ./src/js/actions/entries/bulk_actions.js